import React from 'react';

//MUI
import { IconButton, Tooltip } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

//Xlxs for export
import * as XLSX from 'xlsx';

const ExportarExcel = ({ medicos }) => {
  // Función para exportar a Excel
  const exportarAExcel = () => {
    // Crear un arreglo con los datos para convertir a Excel
    const data = medicos.map((medico) => ({
      "Nombre Completo": medico['name'],
      "Nombre del Promotor": medico['promotor_name'],
      "Fecha de Registro": medico['registration_date']
    }));

    // Crear una hoja de trabajo con los datos
    const ws = XLSX.utils.json_to_sheet(data);

    // Crear un libro de trabajo y agregar la hoja
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Médicos");

    // Guardar el archivo Excel
    XLSX.writeFile(wb, "medicos.xlsx");
  };

  return (
    <Tooltip title='Exportar a Excel'>
      <IconButton onClick={exportarAExcel}>
        <FileDownloadIcon />
      </IconButton>
    </Tooltip>
  );
};

export default ExportarExcel;